import { Box, Skeleton } from '@mui/material';

interface BiggestWinsSkeletonProps {
  rows?: number;
}

export const BiggestWinsSkeleton = ({ rows = 5 }: BiggestWinsSkeletonProps) => {
  const renderSkeletonRow = (_: any, i: number) => (
    <Box
      key={i}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        py: 2.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-child': { borderBottom: 'none', pb: 0 },
      }}
    >
      <Skeleton variant="text" width={20} />
      <Skeleton variant="circular" width={44} height={44} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="40%" />
      </Box>
    </Box>
  );

  return <>{Array.from({ length: rows }).map(renderSkeletonRow)}</>;
};
